import { Alert, Snackbar } from '@mui/material';

import { useAlert } from '../../context/alert/hooks';

export const ToastBar = () => {
  const { alert, removeAlert } = useAlert();

  return (
    <Snackbar
      open={alert.open}
      autoHideDuration={3000}
      onClose={removeAlert}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      <Alert severity={alert?.severity || 'info'} variant="filled">
        {alert.message}
      </Alert>
    </Snackbar>
  );
};
